 


import React, { useEffect, useState } from "react";
import "../src/Signup.css";  
import {  NavLink, useNavigate } from "react-router-dom";
import OTPInput, { ResendOTP } from "otp-input-react";
import { ToastContainer, toast } from 'react-toastify';
import { Api_Url } from "./APIUrl";
import { useLocation } from "react-router-dom";

const Login = () => {
    const [currentScreen, setCurrentScreen] = useState(1);  
    const [count, setCount] = useState(0);  
    const [loading, setLoading] = useState(false);

const navigate = useNavigate() 
  const [number, setNumber] = useState();

  const [OTP, setOTP] = useState("");
 const [Reffer, setrefferal] = useState();


 
  // const LoginApi = () => {
  // setLoading(true)
  //   try {
  //     const myHeaders = new Headers();
  //     myHeaders.append("Content-Type", "application/json");
  
  //     const raw = JSON.stringify({
  //       "mobile_number": number,
  //     });
  
  //     const requestOptions = {
  //       method: "POST",
  //       headers: myHeaders,
  //       body: raw,
  //       redirect: "follow",
  //     };
  
  //     fetch(`${Api_Url}api/login`, requestOptions)
  //       .then((response) => response.json())
  //       .then((result) => {
  //         if (result.success === true) {
  //           toast(result.message);
  //           setCount(1);
   
  //           if (result.data.otp) {
  //             setTimeout(() => {
  //               setOTP(result.data.otp.toString()); 
  //               //  setTimeout(() => {
  //               //   navigate("/home");
  //               //  }, 1500);
  //             }, 3000);
  //           } 
  //         } else {
  //           setNumber(" ");
  //           toast(result.error)
  //         }
  //       })
  //       .catch((error) => console.error(error));
  //   } catch (error) {
  //     toast(error?.message)
  //   }
  //   finally(()=>{setLoading(false)})
  // };



  const handleRefer = (referralCode) => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Bearer ${localStorage.getItem("token")}`);

      const raw = JSON.stringify({
        referral_code: referralCode, 
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(`${Api_Url}/api/update-referral`, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.success == true) {
             setrefferal(result?.reffral)
          
          } else {
            toast("Failed to generate referral code.");
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          toast("An error occurred. Please try again.");
        });
    } catch (error) {
      console.error("Error:", error);
      toast("An unexpected error occurred.");
    }
  };
  const LoginApi = () => {
    setLoading(true);
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        "mobile_number": number,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(`${Api_Url}api/login`, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.success === true) {
            toast(result.message);
            setCount(1);

            if (result.data.otp) {
              setTimeout(() => {
                setOTP(result.data.otp.toString());
               
              }, 3000);




              if (result.data.referral_name) {
                const referralCode = result.data.referral_name;
                handleRefer(referralCode);
              }

            }
          }else if (result.success === "Token has expired") {
            navigate("/");
            localStorage.removeItem("token");
            toast.error(result?.Backend_Error || "Session expired.");
          }  else {
            setNumber(""); // Reset number input if login fails
            toast(result.error);
          }

          
        })
        .catch((error) => console.error(error))
        .finally(() => {
          setLoading(false); // Make sure to set loading to false when request finishes
        });
    } catch (error) {
      toast(error?.message);
      setLoading(false); // Also handle loading state in case of an error
    }
  };
  

  const ValidOTP  =()=>{

    try {
      const myHeaders = new Headers();
myHeaders.append("Content-Type", "application/json"); 

const raw = JSON.stringify({
  "mobile_number": Number(number),
  "otp": Number(OTP),
});

const requestOptions = {
  method: "POST",
  headers: myHeaders,
  body: raw,
  redirect: "follow"
};

fetch(`${Api_Url}api/validate-otp`, requestOptions)
  .then((response) => response.json())
  .then((result) => {
     if(result.success == true){
      localStorage.setItem("token", result.data.token);
      // localStorage.setItem("image", result.data.user.profile_photo);
      localStorage.setItem("userName", result.data.user.name);
      handleRefer()
      toast(result.message)
      navigate("/home")
     }else if (result.message === "Token has expired.") {
      // Token has expired, navigate to the login page
      localStorage.removeItem("token");  // Optionally remove the expired token
      window.location.href = "/";  // Redirect to login page
    }
     else{
      // setTimeout(() => {
      //   setOTP('')
      //   setNumber(' ')
      // }, 3000);
      toast(result.message)
     
     }
  })
  .catch((error) => console.error(error));
    } catch (error) {
      
    }
  }


  const Navigate= useNavigate()
    useEffect(() => { 
      if(!localStorage.getItem('token')){ 
          Navigate("/") 
      }
    }, [])
    

    const location = useLocation();

  useEffect(() => {
    // Extract referral code from query params
    const queryParams = new URLSearchParams(location.search);
    const referralCode = queryParams.get("referral");

    if (referralCode) {
      console.log("Referred by:", referralCode);
      // Optionally, store the referral code in localStorage or state for later use
      localStorage.setItem("referralCode", referralCode);
    }
  }, [location.search]);

  return (
  <>
          <ToastContainer />

  <div className="container-fluid mt-5 pt-3"  style={{height:'88vh', overflow:'hidden'}}  >
    <div className="row">
        <div className="col-lg-12 col-sm-12">

        <div>



        <div className="signup-container pt-5 h-100" style={{ overflowY: "hidden" }}>
      {count === 0 ? (
        <>
          <div>
            <h2 className="text-white" style={{ fontWeight: "bold", fontSize: "24px", marginBottom: "30px" }}>
              Sign In
            </h2>
            <div style={{ position: "relative", marginBottom: "20px" }}>
            <input
  type="number"
  placeholder="Enter your mobile number"
  style={{
    width: "100%",
    padding: "12px 40px",
    border: "1px solid #ccc",
    borderRadius: "8px",
    fontSize: "16px",
  }}
  value={number} // Bind the input value to the state
  onChange={(e) =>
    e.target.value.length <= 10 ? setNumber(e.target.value) : null
  }
/>

              <span
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "10px",
                  transform: "translateY(-50%)",
                  fontSize: "18px",
                  color: "#888",
                }}
              >
                🔗
              </span>
            </div>

            <button className="mt-3"
              style={{
                width: "100%",
                padding: "12px",
                backgroundColor: "#FFD700",
                color: "#000",
                border: "none",
                borderRadius: "8px",
                fontSize: "16px",
                fontWeight: "bold",
                cursor: "pointer",
              }}
              onClick={LoginApi}
              disabled={loading}
            >
              {loading ? "Loading..." : "Continue"}
            </button>

            

            <p className="mt-4" style={{ fontSize: "12px", textAlign: "center", color: "#666" }}>
              By proceeding, you agree to our{" "}
              <NavLink to="/terms" style={{ color: "#007bff", textDecoration: "none" }}>
                Terms of Use
              </NavLink>
              ,{" "}
              <NavLink to="/PrivacyPolicy" style={{ color: "#007bff", textDecoration: "none" }}>
                Privacy Policy
              </NavLink>{" "}
              and that you are 18 years or older.
            </p>
          </div>
        </>
      ) : (
        <>
          <div>
            <h1 style={{ fontWeight: "bold", fontSize: "24px", marginBottom: "20px" }}>OTP</h1>
            <button
              onClick={() => {
                setCount(count - 1);
                setNumber('');
              }}
              style={{
                backgroundColor: "#F3CF41",
                border: "none",
                padding: "10px 15px",
                borderRadius: "5px",
                color: "#000",
                fontWeight: "bold",
                marginBottom: "20px",
              }}
            >
              ← Change Number
            </button>
{/*    
            <OTPInput
  className="py-3"
  value={OTP}  
  onChange={(otp) => setOTP(otp)}  
  OTPLength={6}
  isInputNum
  shouldAutoFocus
  type="number"
  inputStyle={{
    width: "40px",
    height: "40px",
    margin: "5px",
    fontSize: "16px",
    borderRadius: "4px",
    border: "1px solid #ccc",
    textAlign: "center",
    color: "#000",
    backgroundColor: "#fff",
  }}
/> */}

<OTPInput
  className="py-3"
  value={OTP}
  onChange={(otp) => {
    // Strictly allow only numeric characters
    const numericOtp = otp.replace(/[^0-9]/g, ""); // Removes any non-numeric characters
    setOTP(numericOtp);
  }}
  OTPLength={6}
  isInputNum
  shouldAutoFocus
  inputStyle={{
    width: "40px",
    height: "40px",
    margin: "5px",
    fontSize: "16px",
    borderRadius: "4px",
    border: "1px solid #ccc",
    textAlign: "center",
    color: "#000",
    backgroundColor: "#fff",
  }}
/>



            {/* <ResendOTP onResendClick={() =>{LoginApi()}}  className="mt-4 " /> */}



              <div className="my-4">
              <button
              onClick={() => ValidOTP()}
              style={{
                backgroundColor: "#F3CF41",
                border: "none",
                padding: "10px 15px",
                borderRadius: "5px",
                color: "#000",
                fontWeight: "bold",
                marginBottom: "20px",
              }}
            >
              VERIFY
            </button>
              </div>

            
          </div>
        </>
      )}
    </div>
           
    </div>
 
      
        </div>
    </div>
  </div>
  </>
  );
};

export default Login;
